// default styles of a tool is determined by core
// following are the tools that we want to change the default styles due to design
// we could change the default styles in core but we don't want the legacy UI to be affected, so we do it here
export default {
  AnnotationCreateCountMeasurement: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateCountMeasurement2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateCountMeasurement3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateCountMeasurement4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateRectangularAreaMeasurement: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateRectangularAreaMeasurement2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateRectangularAreaMeasurement3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateRectangularAreaMeasurement4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateCloudyRectangularAreaMeasurement: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateCloudyRectangularAreaMeasurement2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateCloudyRectangularAreaMeasurement3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateCloudyRectangularAreaMeasurement4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateEllipseMeasurement: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateEllipseMeasurement2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateEllipseMeasurement3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateEllipseMeasurement4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateAreaMeasurement: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateAreaMeasurement2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateAreaMeasurement3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateAreaMeasurement4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreatePerimeterMeasurement: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreatePerimeterMeasurement2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreatePerimeterMeasurement3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreatePerimeterMeasurement4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateArcMeasurement: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateArcMeasurement2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateArcMeasurement3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateArcMeasurement4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateArc: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateArc2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateArc3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateArc4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateDistanceMeasurement: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateDistanceMeasurement2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateDistanceMeasurement3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateDistanceMeasurement4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateArrow: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateArrow2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateArrow3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateArrow4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateLine: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateLine2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateLine3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateLine4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreatePolyline: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreatePolyline2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreatePolyline3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreatePolyline4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreatePolygonCloud: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreatePolygonCloud2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreatePolygonCloud3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreatePolygonCloud4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreatePolygon: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreatePolygon2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreatePolygon3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreatePolygon4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateRectangle: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateRectangle2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateRectangle3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateRectangle4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateEllipse: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateEllipse2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateEllipse3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateEllipse4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateFreeHand: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateFreeHand2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateFreeHand3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateFreeHand4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateFreeHandHighlight: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateFreeHandHighlight2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateFreeHandHighlight3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateFreeHandHighlight4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateFreeText: {
    TextColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateFreeText2: {
    TextColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateFreeText3: {
    TextColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateFreeText4: {
    TextColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateMarkInsertText: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateMarkInsertText2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateMarkInsertText3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateMarkInsertText4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateMarkReplaceText: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateMarkReplaceText2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateMarkReplaceText3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateMarkReplaceText4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateDateFreeText: {
    TextColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateDateFreeText2: {
    TextColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateDateFreeText3: {
    TextColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateDateFreeText4: {
    TextColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateCallout: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateCallout2: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateCallout3: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateCallout4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateSticky: {
    StrokeColor: { R: 255, G: 205, B: 69, A: 1 },
  },
  AnnotationCreateSticky2: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateSticky3: {
    StrokeColor: { R: 255, G: 141, B: 0, A: 1 },
  },
  AnnotationCreateSticky4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateTextHighlight: {
    StrokeColor: { R: 255, G: 205, B: 69, A: 1 },
  },
  AnnotationCreateTextHighlight2: {
    StrokeColor: { R: 37, G: 210, B: 209, A: 1 },
  },
  AnnotationCreateTextHighlight3: {
    StrokeColor: { R: 0, G: 204, B: 99, A: 1 },
  },
  AnnotationCreateTextHighlight4: {
    StrokeColor: { R: 226, G: 161, B: 230, A: 1 },
  },
  AnnotationCreateTextUnderline: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateTextUnderline2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateTextUnderline3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateTextUnderline4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateTextSquiggly: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateTextSquiggly2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateTextSquiggly3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateTextSquiggly4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateTextStrikeout: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateTextStrikeout2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateTextStrikeout3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateTextStrikeout4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  TextFormFieldCreateTool: {
    TextColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  TextFormFieldCreateTool2: {
    TextColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  TextFormFieldCreateTool3: {
    TextColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  TextFormFieldCreateTool4: {
    TextColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  SignatureFormFieldCreateTool: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  SignatureFormFieldCreateTool2: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  SignatureFormFieldCreateTool3: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  SignatureFormFieldCreateTool4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  ListBoxFormFieldCreateTool: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  ListBoxFormFieldCreateTool2: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  ListBoxFormFieldCreateTool3: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  ListBoxFormFieldCreateTool4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  ComboBoxFormFieldCreateTool: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  ComboBoxFormFieldCreateTool2: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  ComboBoxFormFieldCreateTool3: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  ComboBoxFormFieldCreateTool4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
  AnnotationCreateRedaction: {
    StrokeColor: { R: 255, G: 0, B: 0, A: 1 }
  },
  AnnotationCreateRedaction2: {
    StrokeColor: { R: 0, G: 0, B: 255, A: 1 }
  },
  AnnotationCreateRedaction3: {
    StrokeColor: { R: 255, G: 255, B: 0, A: 1 }
  },
  AnnotationCreateRedaction4: {
    StrokeColor: { R: 0, G: 128, B: 0, A: 1 }
  },
  AnnotationCreateChangeViewTool: {
    StrokeColor: { R: 228, G: 66, B: 52, A: 1 },
  },
  AnnotationCreateChangeViewTool2: {
    StrokeColor: { R: 78, G: 125, B: 233, A: 1 },
  },
  AnnotationCreateChangeViewTool3: {
    StrokeColor: { R: 0, G: 0, B: 0, A: 1 },
  },
  AnnotationCreateChangeViewTool4: {
    StrokeColor: { R: 0, G: 122, B: 59, A: 1 },
  },
};
